import { render, staticRenderFns } from "./EditShareholderCompany.vue?vue&type=template&id=44b2957b&"
import script from "./EditShareholderCompany.vue?vue&type=script&lang=js&"
export * from "./EditShareholderCompany.vue?vue&type=script&lang=js&"
import style0 from "./EditShareholderCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports